import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import AppModel from '../DataModel/AppModel';

/*
The passed "target" object needs to have a property country_code
Which will be set by this component
*/

export default
@observer class SelectCountryCode extends Component {

  setCountryCode(target) {
    return function(event, index, value) {
      target.country_code = value;
    }
  }

  countryChoices() {
    var list = [];
    AppModel.supportedCountries.forEach(function(country) {
      list.push(
        <MenuItem key={country.country_code}
                  value={country.country_code}
                  primaryText={
                    uiMsg('COUNTRY_NAME_'+country.country_code,country.name)                    
                  }/>)
    });
    return list;
  }

  render() {
    var target = this.props.target;
    return (
      <SelectField
          floatingLabelText={uiMsg('SC_SELECT_COUNTRY',"Select country")}
          hintText={uiMsg('SC_SELECT_COUNTRY_HINT',"Select country")}
          value={target.country_code || AppModel.supportedCountries[0].country_code}
          fullWidth={true}
          onChange={this.setCountryCode(target)}>
          {this.countryChoices()}
      </SelectField>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SelectCountryCode.jsx
 **/